import kebabCase from 'lodash/kebabCase'

const routes = {
  root: '/',
  blog: {
    index: '/blog/',
    archive: '/blog/archive/',
    post: title => `/blog${title}`,
    tag: tag => `/blog/tags/${kebabCase(tag)}/`,
  },
  bookshelf: '/bookshelf/',
  info: '/info/',
  uses: '/uses/',
  rss: '/rss.xml',
}

export default routes
